<div fxLayout="row wrap">
    <div fxFlex="100" fxFlex.gt-sm="50" class="p-2">
        <h2 class="text-muted ">Account details</h2>
        <div><label> <b>First Name :</b></label>
            {{userInfo.firstName}}</div>
        <div><label><b>Last Name :</b></label>
            {{userInfo.lastName}}</div>
        <div><label><b>Email :</b></label>
            {{userInfo.email}}</div>

        <div><label><b>Phone :</b></label>
            {{userInfo.phone}}</div>
    </div>
    <div fxFlex="100" fxFlex.gt-sm="50" class="p-2" ngClass.sm="mt-2" ngClass.xs="mt-2">
        <h2 class="text-muted text-center">&nbsp;</h2>

    </div>
</div>